import React, { useState } from 'react';
import { Button } from '@mui/material';
import DocumentLevelChargeAndAllowanceModal from './DocumentLevelChargeAndAllowanceModal';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';
import NestedFieldErrorsAlert from '../../components/NestedFieldErrorsAlert';
import { hasArrayFieldErrors } from '../../utils/apiFieldErrors';

export default function DocumentLevelChargeAndAllowancesButton({
  control,
  readOnly = false,
  currentNetAmount = 0,
  itemBaseAmount = 0,
  invoiceTypeCode,
  profileExecutionId,
  errors,
  restrictToRcm = false,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const { eInvoiceForm } = useTranslatedMessages();
  const buttonLabel = eInvoiceForm?.document_level_charges_allowances?.button_label ?? 'Charges & Allowances';
  const hasNestedErrors = hasArrayFieldErrors(errors, 'allowances') || hasArrayFieldErrors(errors, 'charges');

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <Button
        id="adjustments"
        variant="contained"
        color={hasNestedErrors ? 'error' : 'primary'}
        onClick={handleOpenModal}
      >
        {readOnly ? <VisibilityIcon fontSize="small" sx={{ mr: 1 }} /> : '+ '} {buttonLabel}
      </Button>

      <NestedFieldErrorsAlert errors={errors} arrayName="allowances" itemLabel="Allowance" />
      <NestedFieldErrorsAlert errors={errors} arrayName="charges" itemLabel="Charge" />

      <DocumentLevelChargeAndAllowanceModal
        open={modalOpen}
        onClose={handleCloseModal}
        control={control}
        readOnly={readOnly}
        currentNetAmount={currentNetAmount}
        itemBaseAmount={itemBaseAmount}
        invoiceTypeCode={invoiceTypeCode}
        profileExecutionId={profileExecutionId}
        errors={errors}
        restrictToRcm={restrictToRcm}
      />
    </div>
  );
}
